module.exports = __webpack_public_path__ + "static/media/auth-background.d0556c85.jpg";